import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kap_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401 && window.location.pathname.startsWith("/admin") && !window.location.pathname.includes("/login")) {
      localStorage.removeItem("kap_token");
      localStorage.removeItem("kap_user");
      window.location.href = "/admin/login";
    }
    return Promise.reject(e);
  }
);

// Analytics tracking helper
export const track = async (event, extra = {}) => {
  try {
    await api.post("/track", {
      event,
      path: window.location.pathname,
      referrer: document.referrer || "",
      user_agent: navigator.userAgent,
      ...extra,
    });
  } catch (e) { /* swallow */ }
};
